import { useLightMode } from '@/hooks/useLightMode'
import { usePermissions } from '@/hooks/usePermissions'
import { useTranslation } from 'react-i18next'

import {
  ArrowLeftIcon,
  Button,
  Box as DarkBox,
  EditIcon,
  GuardTourIcon,
  MapPinIcon,
  UtilityButton,
} from '@hivewatch/dark'

import { useAppSelector } from '@/redux/hooks'
import { selectEditMode } from '@/redux/ui/uiSlice'

import {
  detailIconTileStyles,
  detailTitleStyles,
  headerRowStyles,
  metaRowStyles,
  skeletonRowStyles,
} from './DarkTourPlansPanel.styles'

interface DarkTourPlanHeaderIProps {
  onEdit: () => void
  onClose: () => void
  isLoading: boolean
  name: string
  count: number
}

export const DarkTourPlanHeader = ({
  isLoading,
  count,
  name,
  onEdit,
  onClose,
}: DarkTourPlanHeaderIProps) => {
  const colorScheme = useLightMode()
  const { t } = useTranslation()
  const isEditMode = useAppSelector(selectEditMode)
  const { shouldEnableUpdateTourPlan } = usePermissions()

  return (
    <>
      <DarkBox {...headerRowStyles}>
        <UtilityButton
          colorScheme={colorScheme}
          data-testid='tourplan_detail_backButton'
          icon={
            <ArrowLeftIcon colorScheme={colorScheme} height={16} width={16} />
          }
          label={t('floors:plan_tour_go_back_aria')}
          onClick={onClose}
        />
        {/* Same tours glyph as the list row — one object, one icon. */}
        <DarkBox {...detailIconTileStyles(colorScheme)}>
          <GuardTourIcon size={16} />
        </DarkBox>
        <DarkBox
          display='flex'
          flexDirection='column'
          minWidth={0}
          {...(isLoading ? skeletonRowStyles : {})}
        >
          <DarkBox {...detailTitleStyles(colorScheme)}>{name}</DarkBox>
          <DarkBox {...metaRowStyles(colorScheme)}>
            <MapPinIcon colorScheme={colorScheme} size={12} />
            {count}
          </DarkBox>
        </DarkBox>
      </DarkBox>
      <Button
        colorScheme={colorScheme}
        data-testid='tourplan_detail_editButton'
        disabled={!isEditMode || !shouldEnableUpdateTourPlan}
        leftIcon={<EditIcon size={12} />}
        onClick={onEdit}
        style={{ width: '100%' }}
        variant='primary'
      >
        {t('floors:plan_tour_edit_button')}
      </Button>
    </>
  )
}
